// French labels + colors for statuses across TOGOBATI

export const ORDER_STATUS = {
  confirmee: { label: "Confirmée", color: "bg-blue-100 text-blue-700" },
  paiement_confirme: { label: "Paiement confirmé", color: "bg-indigo-100 text-indigo-700" },
  preparee: { label: "Préparée", color: "bg-amber-100 text-amber-700" },
  affectee_tournee: { label: "Affectée à une tournée", color: "bg-amber-100 text-amber-700" },
  en_livraison: { label: "En livraison", color: "bg-orange-100 text-orange-700" },
  livree: { label: "Livrée", color: "bg-green-100 text-green-700" },
  installation_planifiee: { label: "Installation planifiée", color: "bg-cyan-100 text-cyan-700" },
  en_installation: { label: "En cours d'installation", color: "bg-cyan-100 text-cyan-700" },
  installation_terminee: { label: "Installation terminée", color: "bg-green-100 text-green-700" },
  cloturee: { label: "Clôturée", color: "bg-slate-200 text-slate-700" },
};

export const ORDER_STEPS = [
  "confirmee", "paiement_confirme", "preparee", "affectee_tournee",
  "en_livraison", "livree", "installation_planifiee", "en_installation",
  "installation_terminee", "cloturee",
];

export const PAYMENT_STATUS = {
  a_traiter: { label: "À traiter", color: "bg-amber-100 text-amber-700" },
  paye: { label: "Payé", color: "bg-green-100 text-green-700" },
  echoue: { label: "Échoué", color: "bg-red-100 text-red-700" },
};

export const DELIVERY_STATUS = {
  a_preparer: { label: "À préparer", color: "bg-slate-200 text-slate-700" },
  affectee: { label: "Affectée", color: "bg-blue-100 text-blue-700" },
  en_preparation: { label: "En préparation", color: "bg-amber-100 text-amber-700" },
  en_cours: { label: "En cours de livraison", color: "bg-orange-100 text-orange-700" },
  livree: { label: "Livrée", color: "bg-green-100 text-green-700" },
  echouee: { label: "Échec / Annulée", color: "bg-red-100 text-red-700" },
  cloturee: { label: "Clôturée", color: "bg-slate-200 text-slate-700" },
};

export const DELIVERY_STEPS = ["a_preparer", "affectee", "en_preparation", "en_cours", "livree"];

export const INSTALL_STATUS = {
  demande: { label: "Demande reçue", color: "bg-slate-200 text-slate-700" },
  affectee: { label: "Mission affectée", color: "bg-blue-100 text-blue-700" },
  acceptee: { label: "Acceptée", color: "bg-indigo-100 text-indigo-700" },
  refusee: { label: "Refusée", color: "bg-red-100 text-red-700" },
  en_route: { label: "En route", color: "bg-amber-100 text-amber-700" },
  arrive: { label: "Arrivé sur site", color: "bg-amber-100 text-amber-700" },
  commencee: { label: "Installation en cours", color: "bg-orange-100 text-orange-700" },
  terminee: { label: "Terminée", color: "bg-teal-100 text-teal-700" },
  validee: { label: "Validée", color: "bg-green-100 text-green-700" },
  cloturee: { label: "Clôturée", color: "bg-slate-200 text-slate-700" },
};

export const INSTALL_STEPS = ["affectee", "acceptee", "en_route", "arrive", "commencee", "terminee", "validee"];

export const QUOTE_STATUS = {
  demande: { label: "Demande reçue", color: "bg-slate-200 text-slate-700" },
  en_preparation: { label: "En préparation", color: "bg-amber-100 text-amber-700" },
  envoye: { label: "Devis envoyé", color: "bg-blue-100 text-blue-700" },
  accepte: { label: "Accepté", color: "bg-green-100 text-green-700" },
  refuse: { label: "Refusé", color: "bg-red-100 text-red-700" },
  modification_demandee: { label: "Modification demandée", color: "bg-orange-100 text-orange-700" },
};

export const SKILLS = [
  "plomberie", "electricite", "climatisation", "menuiserie", "aluminium",
  "vitrerie", "peinture", "carrelage", "soudure", "installation solaire",
];

export const COMMISSION_STATUS = {
  validee: { label: "Validée", color: "bg-green-100 text-green-700" },
  annulee: { label: "Annulée", color: "bg-red-100 text-red-700" },
};

export const WITHDRAWAL_STATUS = {
  pending: { label: "En attente", color: "bg-amber-100 text-amber-700" },
  approved: { label: "Approuvé", color: "bg-blue-100 text-blue-700" },
  rejected: { label: "Refusé", color: "bg-red-100 text-red-700" },
  paid: { label: "Payé", color: "bg-green-100 text-green-700" },
};

export const INFLUENCER_STATUS = {
  pending: { label: "Candidature", color: "bg-amber-100 text-amber-700" },
  approved: { label: "Actif", color: "bg-green-100 text-green-700" },
  suspended: { label: "Suspendu", color: "bg-slate-200 text-slate-600" },
  rejected: { label: "Refusé", color: "bg-red-100 text-red-700" },
};

export function statusMeta(map, key) {
  return map[key] || { label: key || "—", color: "bg-slate-200 text-slate-700" };
}
